<script lang="ts">
    import Fa from 'svelte-fa'
    import {
        faExclamationTriangle,
        faBuilding,
        faBell,
        faExchangeAlt,
        faFileInvoice,
        faTable,
        faStar,
        faShoppingCart,
        faCalendarAlt,
        faProjectDiagram,
        faChartLine,
        faSearchDollar,
        faPenSquare,
        faCreditCard,
        faRobot,
        faCaretDown,
        faPalette,
        faSun,
        faMoon,
        faTags,
        faCamera,
        faCubes,
        faMoneyCheckAlt,
        faHandshake,
        faFileAlt,
        faLayerGroup,
    } from '@fortawesome/free-solid-svg-icons'
    import { ButtonDropdown, DropdownItem, DropdownMenu, DropdownToggle } from 'sveltestrap'
    import { Link, navigateTo, router } from 'yrv'
    import ActionButton from './action-button.svelte'
    import { onMount } from 'svelte'
    import AlertBar from './alert-bar.svelte'
    import { isFullscreen } from './stores'
    import Screencam from './screencam.svelte'
    import GoalboardButton from './goalboard-button.svelte'
    import type { Goalboard } from '../../modules/toolsApi/goalboards/goalboard.entity'
    import AlertPopup from './alert-popup.svelte'
    import NotificationsBell from './notifications-bell.svelte'

    let current = ''
    let hideMenu = false
    let fullscreen = false

    isFullscreen.subscribe((value) => {
        fullscreen = value
        hideMenu = fullscreen && location.href.includes('tools-goalboard/dash')
    })
    router.subscribe((e) => {
        current = '/' + location.href.split('/')[3]
        hideMenu = fullscreen && location.href.includes('tools-goalboard/dash')
    })

    $: financialLink =
        window.configs?.financialVersionLatest || window.configs?.financialVersionLatest === undefined ? '/financial-4/home' : '/financial/entries'

    $: documentLink = window.configs?.documentVersionLatest ? '/customer-service-v2/forms' : '/customer-service/entries'

    let loading = true
    async function setMenu() {
        currentTheme = (await window.flags('theme', true)) || 'theme_dark'
    }

    async function evaluateHomePage() {
        if (location.pathname === '/') {
            navigateTo('/agenda/all')
            return
        }
    }

    let currentTheme = 'theme_dark'
    async function setTheme(theme) {
        await window.api.utils.utils.setTheme(theme)
        currentTheme = theme
    }

    let version = ''
    onMount(async () => {
        try {
            await setMenu()
            version = window.api.utils.utils.getZanduVersion()
            await evaluateHomePage()
        } catch (error) {
            console.error('template-master.catch.error', error)
        } finally {
            loading = false
        }
        // sem await: depende do tools-api, e o menu não pode esperar por ele. se o servidor travar,
        // o botão de metas só não aparece (ou aparece depois, quando a resposta chegar).
        evaluateMeta().catch((error) => console.error('template-master.evaluateMeta.error', error))
    })

    let showWebcam = false
    function toggleWebcam() {
        showWebcam = !showWebcam
    }

    let metaShowButton = false
    let metaColor = ''
    let metaShowPopup = false
    function goMeta() {
        metaShowPopup = true
    }

    let notify = 0
    let alertComp
    async function goNotify() {
        console.log('checkAlert go')
        await alertComp.checkAlert(true)
    }

    async function evaluateMeta() {
        const goals: Goalboard[] = await window.api.tools.goalboards.getAll()
        for (const goal of goals) {
            if (goal.showIcon && (goal.users.length === 0 || goal.users.some((el) => el === window.store.token.userId))) {
                metaShowButton = true
                return
            }
        }
    }

    function getLogo() {
        if (window.store.company?.logo) return window.store.company.logo
        return '/img/logo_black.png'
    }

    // Cabeçalho da conta: empresa na primeira linha, usuário logado na segunda e as iniciais do
    // usuário no avatar. O store lê do localStorage a cada acesso, então basta ler uma vez aqui.
    const accountCompany: string = window.store.company?.companyName || ''
    const accountUser: string = window.store.user?.userName || ''

    // duas iniciais: primeira e última palavra do nome ("Maria da Silva" → MS); nome de uma
    // palavra só usa as duas primeiras letras. Sem usuário no store (sessão antiga), cai na empresa.
    function initials(name: string) {
        const words = (name || '').trim().split(/\s+/).filter(Boolean)
        if (words.length === 0) return '?'
        if (words.length === 1) return words[0].substring(0, 2).toUpperCase()
        return (words[0][0] + words[words.length - 1][0]).toUpperCase()
    }
    const accountInitials = initials(accountUser || accountCompany)
</script>

{#if showWebcam}
    <Screencam></Screencam>
{/if}

<main>
    <div class="head-print h-screen">
        <div class="company">{window.store.company?.companyName}</div>
        <div class="spacer" />
        <div class="logo"><img src={getLogo()} alt="" /></div>
    </div>

    {#if !loading}
        <AlertBar />
        <AlertPopup bind:this={alertComp} bind:notify></AlertPopup>
        {#if metaShowPopup}
            <GoalboardButton on:close={() => (metaShowPopup = false)}></GoalboardButton>
        {/if}

        <div class="main_head" class:hide-menu={hideMenu}>
            <div class="head-in">
                <div class="logo"><img src="/img/logo_white.png" alt="" /></div>
                {#if window.store.token.permissions.dashboard.show}
                    <Link class="link dash {current === '/dashboard' ? 'active' : ''}" href="/dashboard/home"
                        ><span class="menu_icon-fallback"><Fa icon={faChartLine} /></span><span class="h-mobile">Dashboard</span></Link
                    >
                {/if}
                {#if window.store.token.permissions.scheduler.show}
                    <Link class="link agenda {current === '/agenda' ? 'active' : ''}" href="/agenda/all"
                        ><span class="menu_icon-fallback"><Fa icon={faCalendarAlt} /></span><span class="h-mobile">Agenda</span></Link
                    >
                {/if}
                {#if window.store.token.permissions.pos.show}
                    <Link class="link pos {current === '/pos' ? 'active' : ''}" href="/pos/entries"
                        ><span class="menu_icon-fallback"><Fa icon={faShoppingCart} /></span><span class="h-mobile">PDV</span></Link
                    >
                {/if}
                {#if window.store.token.permissions.customerService.show}
                    <Link class="link atendimento {current.startsWith('/customer-service') ? 'active' : ''} h-mobile" href={documentLink}>Atendimento</Link>
                {/if}
                {#if window.store.token.permissions.pay.show}
                    <Link class="link prospect {current === '/payments' ? 'active' : ''}" href="/payments/purchases"
                        ><span class="menu_icon-fallback"><Fa icon={faCreditCard} /></span><span class="h-mobile">ZanduPay</span></Link
                    >
                {/if}
                {#if window.store.token.permissions.financial.show}
                    <Link class="link financial {current.startsWith('/financial') ? 'active' : ''} h-mobile" href={financialLink}>Financeiro</Link>
                {/if}
                {#if window.store.token.permissions.marketing.show}
                    <Link class="link publico {current === '/automation' ? 'active' : ''} h-mobile h-upto-1279" href="/automation/automations">Automações</Link>
                {/if}
                {#if window.store.token.permissions.pipeline.show}
                    <Link class="link pipeline {current === '/pipeline' ? 'active' : ''} h-mobile h-upto-1279" href="/pipeline">Pipeline</Link>
                {/if}

                <ButtonDropdown>
                    <DropdownToggle color="link" class="link menu_expander {current === '/...' ? 'active' : ''}"><Fa icon={faCaretDown} /></DropdownToggle>
                    <DropdownMenu dark={true}>
                        {#if window.store.token.permissions.audience.show}
                            <Link class="square h-over-1279" href="/automation/automations">
                                <DropdownItem class="dropdown-item-small">
                                    <Fa icon={faRobot} />
                                    Automações</DropdownItem
                                >
                            </Link>
                        {/if}
                        {#if window.store.token.permissions.pipeline.show}
                            <Link class="square h-over-1279" href="/pipeline">
                                <DropdownItem class="dropdown-item-small">
                                    <Fa icon={faTable} /> Pipeline
                                </DropdownItem>
                            </Link>
                        {/if}
                        <!-- {#if window.featureFlags.includes('prospect')}
                            <Link class="square" href="/prospect/entries">
                                <DropdownItem class="dropdown-item-small">
                                    <Fa icon={faSearchDollar} /> Prospectar
                                </DropdownItem>
                            </Link>
                        {/if} -->

                        {#if window.store.token.permissions.balance?.show}
                            <Link class="square" href="/customer-balance/entries">
                                <DropdownItem class="dropdown-item-small">
                                    <Fa icon={faLayerGroup} /> Controle de Saldos
                                </DropdownItem>
                            </Link>
                        {/if}
                        {#if window.store.token.permissions.nps.show}
                            <Link class="square" href="/nps/info">
                                <DropdownItem class="dropdown-item-small">
                                    <Fa icon={faStar} /> NPS
                                </DropdownItem>
                            </Link>
                        {/if}
                        {#if window.store.token.permissions.referral.show}
                            <Link class="square" href="/referral/entries">
                                <DropdownItem class="dropdown-item-small">
                                    <Fa icon={faProjectDiagram} /> Indica
                                </DropdownItem>
                            </Link>
                        {/if}
                        <!-- {#if window.beta && window.store.token.permissions.tags.show}
                            <Link class="square" href="/tags/entries">
                                <DropdownItem class="dropdown-item-small">
                                    <Fa icon={faTags} /> Central de Etiquetas
                                </DropdownItem>
                            </Link>
                        {/if} -->
                        {#if window.store.token.permissions.stock?.show}
                            <Link class="square" href="/stock-v2/home">
                                <DropdownItem class="dropdown-item-small"><Fa icon={faCubes} /> Estoque</DropdownItem>
                            </Link>
                        {/if}
                        {#if window.store.token.permissions.comissions.show && (window.store.token.permissions.comissions.entries.self || window.store.token.permissions.comissions.entries.others)}
                            <Link class="square" href="/comissions/entries">
                                <DropdownItem class="dropdown-item-small"><Fa icon={faMoneyCheckAlt} /> Comissões e Salários</DropdownItem>
                            </Link>
                        {/if}
                        {#if window.featureFlags.includes('partnership')}
                            {#if window.store.token.permissions.partnership?.show}
                                <Link class="square" href="/partners/home">
                                    <DropdownItem class="dropdown-item-small"><Fa icon={faHandshake} /> Parceiros</DropdownItem>
                                </Link>
                            {/if}
                        {/if}
                        {#if window.store.token.permissions.goals?.show}
                            <Link class="square" href="/tools-goalboard/dash">
                                <DropdownItem class="dropdown-item-small">
                                    <Fa icon={faChartLine} /> Metas</DropdownItem
                                >
                            </Link>
                        {/if}
                        {#if window.store.token.permissions.reports?.show}
                            <Link class="square" href="/reports/home">
                                <DropdownItem class="dropdown-item-small"><Fa icon={faFileAlt} /> Relatórios</DropdownItem>
                            </Link>
                        {/if}
                        {#if window.store.token.permissions.reports?.show}
                            <Link class="square" href="/reports-v2/home">
                                <DropdownItem class="dropdown-item-small"><Fa icon={faFileAlt} /> Relatórios V2</DropdownItem>
                            </Link>
                        {/if}
                    </DropdownMenu>
                </ButtonDropdown>

                <div class="spacer" />
                {#if metaShowButton}
                    <a class="square menu-icon {metaColor}" on:click={goMeta}>
                        <Fa icon={faChartLine} />
                    </a>
                {/if}
                {#if notify > 0}
                    <a class="square menu-icon menu-icon-alert" on:click={goNotify}>
                        <Fa icon={faExclamationTriangle} /> Aviso
                    </a>
                {/if}
                <NotificationsBell />
                {#if window.store.token.permissions.tools.show}
                    <ButtonDropdown class="h-mobile">
                        <DropdownToggle color="link" class="link {current === '/resources' ? 'active' : ''}" caret>Ferramentas</DropdownToggle>
                        <DropdownMenu dark={true}>
                            <DropdownItem header class="dropdown-item-small">Cadastros</DropdownItem>
                            {#if window.store.token.permissions.tools.scheduler?.read}
                                <Link href="/tools-scheduler/registration">
                                    <DropdownItem class="dropdown-item-small"><Fa class="dd-svg-padding" icon={faPenSquare} /> Minhas agendas</DropdownItem>
                                </Link>
                            {/if}
                            {#if window.store.token.permissions.tools.scheduler?.read}
                                <Link href="/resources/schedule-groups">
                                    <DropdownItem class="dropdown-item-small"><Fa class="dd-svg-padding" icon={faPenSquare} /> Grupos de agendas</DropdownItem>
                                </Link>
                            {/if}
                            {#if window.store.token.permissions.tools.app?.read}
                                <Link href="/tools-app/config">
                                    <DropdownItem class="dropdown-item-small"><Fa class="dd-svg-padding" icon={faPenSquare} /> Meu Aplicativo</DropdownItem>
                                </Link>
                            {/if}
                            {#if !window.configs?.posPrintVersionLatest && window.configs?.posPrintVersionLatest !== undefined}
                                {#if window.store.token.permissions.tools.docs?.read}
                                    <Link href="/documents/list">
                                        <DropdownItem class="dropdown-item-small"><Fa class="dd-svg-padding" icon={faPenSquare} /> Documentos</DropdownItem>
                                    </Link>
                                {/if}
                            {/if}
                            {#if window.store.token.permissions.tools.referrals?.read}
                                <Link href="/resources/referrals">
                                    <DropdownItem class="dropdown-item-small"><Fa class="dd-svg-padding" icon={faPenSquare} /> Origens do cliente</DropdownItem>
                                </Link>
                            {/if}
                            {#if window.store.token.permissions.tools.services?.read}
                                <Link href="/resources/products">
                                    <DropdownItem class="dropdown-item-small"><Fa class="dd-svg-padding" icon={faPenSquare} /> Produtos</DropdownItem>
                                </Link>
                            {/if}
                            {#if window.store.token.permissions.tools.services?.read}
                                <Link href="/resources/consumables">
                                    <DropdownItem class="dropdown-item-small"><Fa class="dd-svg-padding" icon={faPenSquare} /> Insumos</DropdownItem>
                                </Link>
                            {/if}
                            {#if window.store.token.permissions.tools.services?.read}
                                <Link href="/resources/services">
                                    <DropdownItem class="dropdown-item-small"><Fa class="dd-svg-padding" icon={faPenSquare} /> Serviços</DropdownItem>
                                </Link>
                            {/if}
                            {#if window.store.token.permissions.tools.services?.read}
                                <Link href="/resources/packages">
                                    <DropdownItem class="dropdown-item-small"><Fa class="dd-svg-padding" icon={faPenSquare} /> Pacotes</DropdownItem>
                                </Link>
                            {/if}
                            {#if window.store.token.permissions.tools.services?.read}
                                <Link href="/resources/service-categories">
                                    <DropdownItem class="dropdown-item-small"
                                        ><Fa class="dd-svg-padding" icon={faPenSquare} /> Categorias de serviços</DropdownItem
                                    >
                                </Link>
                            {/if}
                            {#if window.store.token.permissions.tools.resources?.read}
                                <Link href="/resources-lock/entries">
                                    <DropdownItem class="dropdown-item-small"><Fa class="dd-svg-padding" icon={faPenSquare} /> Salas e Aparelhos</DropdownItem>
                                </Link>
                            {/if}
                            {#if window.store.token.permissions.tools.payments?.read}
                                <Link href="/resources/payments">
                                    <DropdownItem class="dropdown-item-small"><Fa class="dd-svg-padding" icon={faPenSquare} /> Meios de Pagamento</DropdownItem>
                                </Link>
                            {/if}
                            {#if window.store.token.permissions.tools.accounts?.read}
                                <Link href="/resources/accounts">
                                    <DropdownItem class="dropdown-item-small"><Fa class="dd-svg-padding" icon={faPenSquare} /> Contas bancárias</DropdownItem>
                                </Link>
                            {/if}
                            {#if window.store.token.permissions.tools.categories?.read}
                                <Link href="/resources/categories">
                                    <DropdownItem class="dropdown-item-small"
                                        ><Fa class="dd-svg-padding" icon={faPenSquare} /> Categorias financeiras</DropdownItem
                                    >
                                </Link>
                            {/if}
                            {#if window.store.token.permissions.tools.payGateways?.read}
                                <Link href="/resources/payments-gateways">
                                    <DropdownItem class="dropdown-item-small"
                                        ><Fa class="dd-svg-padding" icon={faPenSquare} /> Gateways de pagamento</DropdownItem
                                    >
                                </Link>
                            {/if}
                            {#if window.store.token.permissions.tools.customerService?.read}
                                <Link href="/resources/customer-service-models">
                                    <DropdownItem class="dropdown-item-small"
                                        ><Fa class="dd-svg-padding" icon={faPenSquare} /> Modelos de Atendimento (legado)</DropdownItem
                                    >
                                </Link>
                                <Link href="/resources/customer-service-v2">
                                    <DropdownItem class="dropdown-item-small"
                                        ><Fa class="dd-svg-padding" icon={faPenSquare} /> Modelos de Atendimento (novo)</DropdownItem
                                    >
                                </Link>
                            {/if}
                            {#if window.store.token.permissions.tools.quotation?.read}
                                <Link href="/resources/pos-quotation-models">
                                    <DropdownItem class="dropdown-item-small"
                                        ><Fa class="dd-svg-padding" icon={faPenSquare} /> Modelos de Orçamento</DropdownItem
                                    >
                                </Link>
                            {/if}
                            {#if window.store.token.permissions.tools.goals?.read}
                                <Link href="/resources/goalboard-config">
                                    <DropdownItem class="dropdown-item-small"
                                        ><Fa class="dd-svg-padding" icon={faPenSquare} /> Configurações de Metas</DropdownItem
                                    >
                                </Link>
                            {/if}
                            {#if window.store.token.permissions.tools.posTaxParams?.read}
                                <Link href="/resources/tax-params">
                                    <DropdownItem class="dropdown-item-small"
                                        ><Fa class="dd-svg-padding" icon={faFileInvoice} /> Configurações de Notas Fiscais</DropdownItem
                                    >
                                </Link>
                            {/if}

                            {#if window.store.token.permissions.super}
                                <DropdownItem class="dropdown-item-small-divider" divider />
                                <DropdownItem header class="dropdown-item-small">Outros</DropdownItem>
                                <Link href="/resources/resources-manager">
                                    <DropdownItem class="dropdown-item-small">Configurações Gerais</DropdownItem>
                                </Link>
                                <!-- <Link href="/resources/importacoes">
                                    <DropdownItem class="dropdown-item-small">Migrações automáticas</DropdownItem>
                                </Link> -->
                                <Link href="/onboarding">
                                    <DropdownItem class="dropdown-item-small">Onboarding</DropdownItem>
                                </Link>
                                <Link href="/resources/eventos">
                                    <DropdownItem class="dropdown-item-small">Log de eventos</DropdownItem>
                                </Link>
                                {#if window.featureFlags.includes('chat')}
                                    <Link href="/resources/channelslog">
                                        <DropdownItem class="dropdown-item-small">Log dos provedores</DropdownItem>
                                    </Link>
                                {/if}
                                {#if window.featureFlags.includes('cam')}
                                    <div on:click={toggleWebcam}>
                                        <DropdownItem class="dropdown-item-small"><Fa icon={faCamera} /> Webcam</DropdownItem>
                                    </div>
                                {/if}

                                <!-- <DropdownItem divider />
                        <Link href="/ferramentas/apps">
                            <DropdownItem>Aplicativos</DropdownItem>
                        </Link> -->
                            {/if}
                        </DropdownMenu>
                    </ButtonDropdown>
                {/if}
                <div class="menu_divider"></div>
                <ButtonDropdown>
                    <DropdownToggle color="link" class="link menu_account {current === '/conta' ? 'active' : ''}" caret
                        ><span class="menu_account-avatar"><div class="-avatar-in">{accountInitials}</div></span><span class="menu_account-text h-upto-1279"
                            ><span class="menu_account-company">{accountCompany}</span><span class="menu_account-user">{accountUser}</span></span
                        ></DropdownToggle
                    >
                    <DropdownMenu dark={true}>
                        <DropdownItem header class="dropdown-item-small">Segurança</DropdownItem>
                        <Link href="/resources/password-change">
                            <DropdownItem>Alterar senha</DropdownItem>
                        </Link>
                        {#if window.store.token.permissions.account.users?.read}
                            <Link href="/resources/usuarios">
                                <DropdownItem>Usuários</DropdownItem>
                            </Link>
                        {/if}
                        {#if window.store.token.permissions.account.devices?.read}
                            <Link href="/resources/devices">
                                <DropdownItem>Dispositivos e API</DropdownItem>
                            </Link>
                        {/if}
                        <DropdownItem divider />
                        <Link href="/personalize/notifications">
                            <DropdownItem><Fa class="dd-svg-padding" icon={faBell} /> Minhas Notificações</DropdownItem>
                        </Link>
                        {#if window.store.token.permissions.account.users?.read}
                            <Link href="/resources/empresas">
                                <DropdownItem><Fa class="dd-svg-padding" icon={faBuilding} /> Minhas empresas</DropdownItem>
                            </Link>
                        {/if}
                        <!-- {#if window.store.token.permissions.account.users?.read && window.store.user.planCompanies > 1} -->
                        <Link href="/companies/select">
                            <DropdownItem><Fa class="dd-svg-padding" icon={faExchangeAlt} /> Acessar outra empresa</DropdownItem>
                        </Link>
                        <DropdownItem divider />
                        <Link href="/resources/subscription">
                            <DropdownItem>Minha assinatura</DropdownItem>
                        </Link>
                        <!-- {/if} -->
                        <DropdownItem divider />
                        <div class="menu_theme">
                            <div class="label">Tema</div>
                            <button on:click={() => setTheme('theme_light')} class="menu_them_item" class:menu_theme_active={currentTheme === 'theme_light'}
                                ><Fa icon={faSun}></Fa></button
                            >
                            <button on:click={() => setTheme('theme_dark')} class="menu_them_item" class:menu_theme_active={currentTheme === 'theme_dark'}
                                ><Fa icon={faMoon}></Fa></button
                            >
                        </div>
                        <DropdownItem divider />
                        <div on:click={window.logout}>
                            <DropdownItem>Sair</DropdownItem>
                        </div>
                        <div class="version">{version}</div>
                    </DropdownMenu>
                </ButtonDropdown>
            </div>
        </div>

        {#if window.screen.width > 900 && !hideMenu}
            <ActionButton />
        {/if}
    {/if}

    <div class="body scroll-dark">
        <slot />
    </div>
</main>

<style>
    main {
        background-color: rgb(22, 22, 22);
        color: rgb(238, 238, 238);
        height: 100vh;
        overflow: hidden;
        position: relative;
        display: flex;
        flex-direction: column;
    }

    .hide-menu {
        display: none !important;
    }

    .main_head {
        background-color: rgb(var(--head-color));
        flex: 0 0 auto;
        display: flex;
        z-index: 997;
        border-bottom: 1px solid #66666620;
    }
    .head-in {
        display: flex;
        justify-content: center;
        align-items: center;
        max-width: 95%;
        max-width: 1600px;
        margin: 0 auto;
        flex-grow: 1;
    }
    /* menu só com rótulos: todos em tom suave e o destaque fica para o item ativo, numa pílula
       translúcida — em vez de cada opção disputar atenção com ícone colorido */
    .main_head :global(.link) {
        font-size: 14px;
        font-weight: 500;
        display: block;
        text-decoration: none;
        color: rgba(var(--menu-color), 0.9);
        padding: 6px 12px !important;
        border: 0px;
        text-shadow: unset;
        margin: 6px 2px;
        border-radius: 8px;
        transition:
            background-color 0.15s ease,
            color 0.15s ease;
    }
    .main_head :global(.link:hover) {
        background: #ffffff0f;
        color: #fff;
    }

    /* mesmo peso do inativo: negrito no ativo mudaria a largura e o menu "pularia" ao navegar */
    .main_head :global(.active) {
        background: #ffffff1f;
        color: #fff;
    }

    /* ícone de reserva: só aparece quando o rótulo some (abaixo de 900px) */
    .main_head :global(.menu_icon-fallback) {
        display: none;
    }
    @media (max-width: 900px) {
        .main_head :global(.menu_icon-fallback) {
            display: inline-flex;
        }
    }

    /* ---- final do menu: atalhos, ferramentas e conta ---- */

    /* atalhos só de ícone (metas, aviso, notificações): sem a caixinha em volta do ícone, no mesmo
       tom suave dos rótulos e com a mesma pílula no hover. Só os filhos diretos da barra: os itens do
       dropdown do botão vermelho também usam a classe "square" e não podem herdar isso. */
    .head-in > :global(.square) {
        display: flex;
        align-items: center;
        gap: 6px;
        margin: 6px 2px;
        padding: 8px 10px;
        border-radius: 8px;
        color: rgba(var(--menu-color), 0.9);
        transition:
            background-color 0.15s ease,
            color 0.15s ease;
    }
    .head-in > :global(.square:hover) {
        background: #ffffff0f;
        color: #fff;
    }
    /* o aviso segue amarelo: é um alerta, não um atalho comum */
    .head-in > :global(.square.menu-icon-alert) {
        color: #ffc107;
    }
    .head-in > :global(.square svg) {
        width: auto;
        height: 16px !important;
        padding: 0px;
        margin-right: 0px;
        border: 0px;
        background-color: transparent;
    }

    .menu_divider {
        flex: 0 0 1px;
        height: 24px;
        margin: 0px 8px;
        background-color: #ffffff26;
    }

    .main_head :global(.menu_account) {
        gap: 10px;
        padding: 4px 10px 4px 4px !important;
    }
    .menu_account-avatar {
        flex: 0 0 32px;
        width: 32px;
        height: 32px;
        border-radius: 50%;
        display: flex;
        text-align: center;
        justify-content: center;
        background-color: #6fd3a5;
        color: #0d3b28;
        font-size: 13px;
        font-weight: 700;
        letter-spacing: 0.5px;
    }
    .menu_account-avatar .-avatar-in {
        display: flex;
        align-items: center;
        padding-left: 2px;
        padding-top: 2px;
    }
    .menu_account-text {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        min-width: 0;
        line-height: 1.2;
        text-align: left;
    }
    /* nomes longos cortam com reticências em vez de empurrar o menu */
    .menu_account-company,
    .menu_account-user {
        max-width: 180px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
    .menu_account-company {
        font-size: 14px;
        font-weight: 600;
        color: #fff;
    }
    .menu_account-user {
        font-size: 12px;
        font-weight: 400;
        opacity: 0.7;
    }
    .main_head :global(.active svg) {
        background: unset;
        border: unset;
    }
    .main_head :global(.dash svg) {
        color: rgb(var(--dash-color));
    }
    .main_head :global(.pipeline svg) {
        color: rgb(var(--pipeline-color));
    }
    .main_head :global(.nps svg) {
        color: rgb(var(--nps-color));
    }
    .main_head :global(.agenda svg) {
        color: rgb(156, 77, 204);
    }
    .main_head :global(.pos svg) {
        color: rgb(var(--pos-color));
    }
    .main_head :global(.automacao svg) {
        color: rgb(var(--automacao-color));
    }
    .main_head :global(.indica svg) {
        color: rgb(var(--indica-color));
    }
    .main_head :global(.prospect svg) {
        color: rgb(var(--prospect-color));
    }
    .main_head :global(.financial svg) {
        color: rgb(var(--finan-color));
    }
    .main_head :global(.atendimento svg) {
        color: rgb(var(--audience-color));
    }

    .body {
        overflow-y: auto;
        flex: 1 1 auto;
        max-height: 100%;
        border: 0px solid cyan;
    }
    .version {
        padding-right: 16px;
        color: #99999950;
        font-size: 12px;
        text-align: right;
    }
    .main_head :global(.h-over-1279) {
        display: none;
    }

    .menu-change {
        font-size: 13px;
        text-align: center;
        opacity: 0.6;
        padding: 4px 2px;
    }
    .menu-icon {
        margin: 7px 6px 6px 6px;
        display: flex;
    }
    .menu-icon svg {
        margin-right: unset !important;
        color: #ffc107;
    }

    .menu-icon-alert {
        color: #ffc107;
    }

    @media (max-width: 1279px) {
        .main_head :global(.link) {
            padding: 6px 8px !important;
        }
        .main_head :global(.h-upto-1279) {
            display: none !important;
        }
        .main_head :global(.h-over-1279) {
            display: unset;
        }
    }
</style>
